/* © 2026 Trinchebalk */
/* Rome civil calendar: independent of the browser's timezone, including DST. */
(function(root) {
  const zone = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
  function civil(now) {
    const p = Object.fromEntries(zone.formatToParts(now).map(p => [p.type,p.value]));
    return new Date(Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second));
  }
  function instant(wall) {
    let n = +wall;
    for (let i=0;i<3;i++) n += +wall - +civil(new Date(n));
    return n;
  }
  function easter(y) {
    const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
    return new Date(Date.UTC(y,Math.floor(n/31)-1,n%31+1));
  }
  function business(d) {
    const md=(d.getUTCMonth()+1)+'-'+d.getUTCDate(), monday=easter(d.getUTCFullYear());monday.setUTCDate(monday.getUTCDate()+1);
    return !(md==='10-4' && d.getUTCFullYear()>=2026) && ![0,6].includes(d.getUTCDay()) && !['1-1','1-6','4-25','5-1','6-2','8-15','11-1','12-8','12-25','12-26'].includes(md) && md!==(monday.getUTCMonth()+1)+'-'+monday.getUTCDate();
  }
  function add(d,n) { const out=new Date(d);while(n>0){out.setUTCDate(out.getUTCDate()+1);if(business(out))n--;}return out; }
  function calculate(now, country, custom=false, etaDays=0) {
    const wall=civil(now), deadline=new Date(wall);deadline.setUTCMinutes(0,0,0);
    if(business(wall)&&wall.getUTCHours()<18) deadline.setUTCHours(18);
    else {deadline.setUTCDate(deadline.getUTCDate()+1);deadline.setUTCHours(18);while(!business(deadline))deadline.setUTCDate(deadline.getUTCDate()+1);}
    const start=new Date(wall);start.setUTCHours(0,0,0,0);
    if(!business(start)||wall.getUTCHours()>=18){if(business(start))start.setUTCDate(start.getUTCDate()+1);while(!business(start))start.setUTCDate(start.getUTCDate()+1);}
    // Luis N18: the same delivery window for standard and personalised products.
    // Explicit section settings remain a conservative minimum.
    const min=Math.max(country==='IT'?1:4,Number(etaDays)||0);
    const max=Math.max(country==='IT'?3:8,min);
    return {active:business(wall)&&wall.getUTCHours()<18,from:add(start,min),to:add(start,max),minutes:Math.max(1,Math.ceil((instant(deadline)-+now)/60000)),deadline:new Date(instant(deadline)),min,max};
  }
  const api={calculate,business};
  if(typeof module==='object'&&module.exports)module.exports=api;else root.TBPDelivery=api;
})(typeof window==='object'?window:globalThis);
